export default {"src":"/_next/static/media/pdf_document_40.6f88c461.svg","height":40,"width":40,"blurWidth":0,"blurHeight":0};